import React, { Component } from 'react';
import quizQuestions from './api/quizQuestions';
import Quiz from './components/Quiz';
import Result from './components/Result';
// import logo from './svg/logo.svg';
import './App.css';

class App extends Component {
  constructor(props) {
    super(props);

    this.state = {
      counter: 0,
      questionId: 1,
      question: '',
      answerOptions: [],
      images: [],
      points: 0,
      answer: '',
      answersCount: {},
      result: '',
      showRules: true
    };

    this.handleAnswerSelected = this.handleAnswerSelected.bind(this);
  }

  componentDidMount() {
    const shuffledAnswerOptions = quizQuestions.map(question =>
      this.shuffleArray(question.answers)
    );
    this.setState({
      question: quizQuestions[0].question,
      answerOptions: shuffledAnswerOptions[0],
      images: quizQuestions[0].images
    });
  }

  shuffleArray(array) {
    var currentIndex = array.length,
      temporaryValue,
      randomIndex;

    // While there remain elements to shuffle...
    while (0 !== currentIndex) {
      // Pick a remaining element...
      randomIndex = Math.floor(Math.random() * currentIndex);
      currentIndex -= 1;

      // And swap it with the current element.
      temporaryValue = array[currentIndex];
      array[currentIndex] = array[randomIndex];
      array[randomIndex] = temporaryValue;
    }

    return array;
  }

  handleAnswerSelected(event) {
    this.setUserAnswer(event.currentTarget.value, event.target.getAttribute('points'));

    if (this.state.questionId < quizQuestions.length) {
      setTimeout(() => this.setNextQuestion(), 300);
    } else {
      setTimeout(() => this.setResults(this.getResults()), 300);
    }
  }

  setUserAnswer(answer, points) {
    this.setState((state, props) => ({
      answersCount: {
        ...state.answersCount,
        [answer]: (state.answersCount[answer] || 0) + 1
      },
      answer: answer,
      points: state.points + parseInt(points)
    }));
  }

  setNextQuestion() {
    const counter = this.state.counter + 1;
    const questionId = this.state.questionId + 1;

    this.setState({
      counter: counter,
      questionId: questionId,
      question: quizQuestions[counter].question,
      answerOptions: quizQuestions[counter].answers,
      images: quizQuestions[counter].images,
      answer: ''
    });
    window.scrollTo({ top: document.querySelector('.App-header').clientHeight, behavior: 'smooth' });

  }

  getResults() {
    const answersCount = this.state.answersCount;
    const answersCountKeys = Object.keys(answersCount);
    const answersCountValues = answersCountKeys.map(key => answersCount[key]);
    const maxAnswerCount = Math.max.apply(null, answersCountValues);

    return answersCountKeys.filter(key => answersCount[key] === maxAnswerCount);
  }

  setResults(result) {
    if (result.length === 1) {
      this.setState({ result: result[0] });
    } else {
      this.setState({ result: 'none' });
    }
  }

  renderQuiz() {
    return (
      <>
        {this.state.showRules &&
          this.renderRules()
        }
        {!this.state.showRules &&
          <Quiz
            answer={this.state.answer}
            answerOptions={this.state.answerOptions}
            images={this.state.images}
            points={this.state.points}
            questionId={this.state.questionId}
            question={this.state.question}
            questionTotal={quizQuestions.length}
            onAnswerSelected={this.handleAnswerSelected}
          />
        }
      </>
    );
  }

  setShowRules() {
    this.setState({showRules: false});
    window.scrollTo({ top: document.querySelector('.App-header').clientHeight, behavior: 'smooth' });
  }

  renderRules() {
    return (
      <div className='rules'>
         <h2>Quiz za Real Estate agente</h2>
         <img className='medal' src={`https://dcjau2yrh9nxo.cloudfront.net/images/nekretnine/agent.png`} alt='' />
        <h2>Pravila:</h2>
        <ul>
          <li>Što približnije pogoditi cenu na osnovu slika</li>
          <li>Svako pitanje nosi max 10 poena</li>
          <li>No googling!</li>

        </ul>
        <p>
          <button type='button' className='next' onClick={() => this.setShowRules()}>
            OK
          </button>
        </p>
      </div>
    )
  }

  renderResult() {
    return <Result points={this.state.points} medal={this.state.result} total={quizQuestions.length * 10} />;
  }

  render() {
    return (
      <div className="App">
        <div className="App-header" onClick={() => window.location.reload(false)}>
          <img src='/logo.png' className="App-logo" alt="logo" />
          <h2>Agencija <div className='halo-bing'>"Halo Bing!"</div></h2>
        </div>
        {this.state.result ? this.renderResult() : this.renderQuiz()}
      </div>
    );
  }
}

export default App;
